export default __webpack_public_path__ + "static/media/350.52064827.gif";